import React, { useState, useRef } from 'react';
import { Modal, message } from 'antd';
import { useParams } from 'react-router-dom';
import {
  EpisodeTypeList,
  osOptions,
  OtomeEpisodeTypeList,
  productType,
} from 'utils/constant';
import { theme } from 'utils/style/theme';
import { episodeApi } from 'apis/story/episodeApis';
import VerticalForm from 'components/form/DefaultForm';
import DefaultRadio from 'components/input/DefaultRadio';
import DefaultInput from 'components/input/DefaultInput';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import PrimaryButton from 'components/button/PrimaryButton';
import { productApis } from '../../../apis/package/productApis';
import { ICoupon } from '../../../utils/types/saleTypes';
import { INotice } from '../../../utils/types/operationTypes';
import { noticeApis } from '../../../apis/operation/noticeApis';
/**
 * * 에피소드 & 오토메 에피 등록 모달
 */
interface IProps {
  visible: boolean;
  setVisible: (e: any) => void;
  fetchData: () => void;
}

const NoticeRegisterModal: React.FC<IProps> = ({
  visible,
  setVisible,
  fetchData,
}) => {
  const { t } = useTranslation();
  const { projectId } = useParams();
  const [inputData, setInputData] = useState<INotice>({
    notice_id: 0,
    notice_type: 'general',
    notice_name: '',
    project_id: Number(projectId),
    from_date: '',
    to_date: '',
    os: 'all',
    sortkey: 0,
    exception_culture: '',
    details: [],
  });

  /// 인풋
  const handleInputChange = (e) => {
    setInputData({ ...inputData, [e.target.name]: e.target.value });
  };

  const [loading, setLoading] = useState(false);

  /// 등록하기
  const handleSubmit = async () => {
    if (inputData?.notice_name === '') {
      message.error('제품 제목을 입력하세요.', 1);
      return;
    }

    try {
      setLoading(true);

      const res = await noticeApis.createNotice(Number(projectId), inputData);

      setVisible(false);
      fetchData();
      setLoading(false);
      message.success(' 등록 완료', 1);
    } catch (err) {
      setLoading(false);
      console.log('create episode error:', err);
    }
  };

  /// 모달 닫기
  const handleCancel = () => {
    setVisible(false);
  };

  return (
    <CustomModal
      title={'공지 등록'}
      visible={visible}
      onCancel={handleCancel}
      footer={
        <FooterBtnWrapper>
          <PrimaryButton
            text={'등록하기'}
            height='40px'
            width='fit-content'
            bgColor={theme.colors.primary}
            textColor='#ffffff'
            fontWeight={theme.fontWeights.medium}
            fontSize={theme.fontSizes.normal}
            border={`1px solid ${theme.colors.primary}`}
            rounded='6px'
            hoverBgColor={theme.colors.primary}
            activeBgColor={theme.colors.primary}
            selectedBgColor={theme.colors.primary}
            onClick={handleSubmit}
            loading={loading}
            disabled={loading}
          />
        </FooterBtnWrapper>
      }
    >
      <VerticalForm margin='0'>
        <DefaultRadio
          title={'os 타입'}
          name='os'
          optionList={osOptions}
          defaultValue={inputData.os}
          onChange={handleInputChange}
        />

        <DefaultInput
          title={'공지 제목'}
          name='notice_name'
          maxLength={60}
          value={inputData.notice_name}
          onChange={handleInputChange}
          placeholder={'공지 제목을 입력하세요.'}
        />

        <p className='length-subtext'>
          {typeof inputData.notice_name?.length === 'number'
            ? `${inputData.notice_name?.length}/30 characters`
            : '0/30 characters'}
        </p>
      </VerticalForm>
    </CustomModal>
  );
};

export default NoticeRegisterModal;

const CustomModal = styled(Modal)`
  .length-subtext {
    font-size: ${theme.fontSizes.sm};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
    margin-top: 8px !important;
    font-size: ${theme.fontSizes.normal};
    font-weight: ${theme.fontWeights.normal};
    color: ${theme.colors.dark_200};
  }

  .ant-modal-body {
    padding: 0;
  }

  label {
    margin-left: 0;
    font-size: ${theme.fontSizes.sm};
    font-weight: ${theme.fontWeights.medium};
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${theme.colors.dark_500};
    margin-bottom: 8px !important;
  }

  .ant-modal-content {
    box-shadow: none;
  }

  .ant-radio-wrapper {
    span {
      font-size: ${theme.fontSizes.normal};
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0.2px;
      color: ${theme.colors.dark_500};
    }
  }

  .ant-modal-footer {
    margin-top: 10px !important;
  }

  .ant-input-show-count-suffix {
    display: none;
  }
`;

const FooterBtnWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;
